import { makeUseLangCookie } from 'cf-i18n/cookies'

import { isSupportedLocale } from '../locales'
import type { Locale } from '../locales'

export const useLangCookie = makeUseLangCookie<Locale>(isSupportedLocale)
